import React from 'react';
import { useCategory } from '../../context/CategoryContext.tsx';
import { Box, Container, Grid, Typography, Link, IconButton, TextField, Button } from '@mui/material';
import { Facebook, Instagram, Twitter, YouTube, Phone, Email, LocationOn, Schedule, Send } from '@mui/icons-material';
import { motion } from 'framer-motion';

const Footer: React.FC = () => {
  const { setSelectedCategory } = useCategory();

  const handleFooterCategory = (category: string) => {
    const categoryList = ['All', 'Sofas', 'Beds', 'Recliners', 'Chairs', 'Wall Padding'];
    const idx = categoryList.indexOf(category);
    setSelectedCategory(idx > -1 ? idx : 0);
    window.location.href = '/#products';
  };

  const socialLinks = [
    { icon: <Facebook />, url: 'https://www.facebook.com/share/17YVr8U5Je/', label: 'Facebook', color: '#1877F2' },
    { icon: <Instagram />, url: 'https://www.instagram.com/ahmed.shareef1983', label: 'Instagram', color: '#E4405F' },
    { icon: <Twitter />, url: '#', label: 'Twitter', color: '#1DA1F2' },
    { icon: <YouTube />, url: '#', label: 'YouTube', color: '#FF0000' },
  ];

  const quickLinks = [
    { text: 'Bulk Orders', href: '/#products' },
    { text: 'Custom Designs', href: 'https://wa.me/916309561983', external: true },
    { text: 'Contact Us', href: '/contact' },
  ];

  const categories = ['Sofas', 'Beds', 'Recliners', 'Chairs'];

  return (
    <Box component="footer" id="contact" sx={{ backgroundColor: '#FFFFFF !important', color: '#5C4A3D', pt: 3, pb: 1.5, mt: 'auto' }}>
      <Container maxWidth="lg">
        <Grid container spacing={2}>
          <Grid item xs={12} md={5}>
            <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} viewport={{ once: true }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1.5 }}>
                <Box component="img" src="/images/products/Logo without BG.png" alt="Logo" sx={{ height: 95, width: 'auto', objectFit: 'contain' }} />
                <Box sx={{ display: 'flex', flexDirection: 'column', ml: 2, alignItems: 'center' }}>
                  <Typography variant="h6" sx={{ fontFamily: '"Cinzel", serif', fontWeight: 700, color: '#8B7355', letterSpacing: '1px', fontSize: '1rem', margin: 0, textTransform: 'uppercase', textAlign: 'center', lineHeight: 1.2 }}>
                    AHMED SHAREEF
                  </Typography>
                  <Typography variant="caption" sx={{ fontFamily: '"Playfair Display", serif', color: 'rgba(139,115,85,0.7)', fontSize: '0.75rem', fontWeight: 400, letterSpacing: '1px', textTransform: 'none', textAlign: 'center', fontStyle: 'italic' }}>
                    Sofa makers
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                  <LocationOn sx={{ fontSize: '1rem', color: '#8B7355', mt: 0.3, flexShrink: 0 }} />
                  <Typography variant="body2" sx={{ fontSize: '0.8rem', color: '#5C4A3D', lineHeight: 1.4 }}>
                    Plot No 228, Manikonda, Hyderabad, Telangana 500089
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Phone sx={{ fontSize: '1rem', color: '#8B7355' }} />
                  <Typography variant="body2" sx={{ fontSize: '0.85rem', color: '#5C4A3D' }}>
                    +91 6309561983
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Email sx={{ fontSize: '1rem', color: '#8B7355' }} />
                  <Typography variant="body2" sx={{ fontSize: '0.85rem', color: '#5C4A3D' }}>
                    Ahmed83shareef@gmail.com
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Schedule sx={{ fontSize: '1rem', color: '#8B7355' }} />
                  <Typography variant="body2" sx={{ fontSize: '0.85rem', color: '#5C4A3D' }}>
                    Mon-Sat: 9AM-7PM
                  </Typography>
                </Box>
              </Box>
            </motion.div>
          </Grid>

          <Grid item xs={6} sm={4} md={2}>
            <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.1 }} viewport={{ once: true }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1.5, fontSize: '1rem', color: '#8B7355' }}>
                Quick Links
              </Typography>
              <Box>
                {quickLinks.map((link, index) => (
                  <Link key={index} href={link.href} target={link.external ? '_blank' : undefined} sx={{ display: 'block', color: '#5C4A3D', textDecoration: 'none', mb: 0.5, fontSize: '0.85rem', cursor: 'pointer', '&:hover': { color: '#8B7355', textDecoration: 'underline' } }}>
                    {link.text}
                  </Link>
                ))}
              </Box>
            </motion.div>
          </Grid>

          <Grid item xs={6} sm={4} md={2}>
            <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.2 }} viewport={{ once: true }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1.5, fontSize: '1rem', color: '#8B7355' }}>
                Categories
              </Typography>
              <Box>
                {categories.map((category, index) => (
                  <Link key={index} onClick={() => handleFooterCategory(category)} sx={{ display: 'block', color: '#5C4A3D', textDecoration: 'none', mb: 0.5, fontSize: '0.85rem', cursor: 'pointer', '&:hover': { color: '#8B7355', textDecoration: 'underline' } }}>
                    {category}
                  </Link>
                ))}
              </Box>
            </motion.div>
          </Grid>

          <Grid item xs={12} md={3}>
            <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.3 }} viewport={{ once: true }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1.5, fontSize: '1rem', color: '#8B7355' }}>
                Stay Updated
              </Typography>
              <Box sx={{ display: 'flex', mb: 1.5 }}>
                <TextField placeholder="Enter your email" variant="outlined" size="small" sx={{ flexGrow: 1, mr: 1, '& .MuiOutlinedInput-root': { backgroundColor: '#FFFFFF', '& fieldset': { borderColor: 'rgba(139,115,85,0.3)' }, '&:hover fieldset': { borderColor: 'rgba(139,115,85,0.5)' }, '&.Mui-focused fieldset': { borderColor: '#8B7355' } }, '& .MuiInputBase-input': { color: '#5C4A3D', '&::placeholder': { color: 'rgba(139,115,85,0.6)', opacity: 1 } } }} />
                <Button variant="contained" sx={{ backgroundColor: '#8B7355', color: 'white', minWidth: 'auto', px: 2, '&:hover': { backgroundColor: '#8B7355' } }}>
                  <Send />
                </Button>
              </Box>
              <Typography variant="subtitle2" sx={{ mb: 0.8, fontWeight: 'bold', fontSize: '0.85rem', color: '#8B7355' }}>
                Follow Us
              </Typography>
              <Box>
                {socialLinks.map((social, index) => (
                  <IconButton key={index} href={social.url} sx={{ color: social.color, mr: 1, '&:hover': { opacity: 0.8, backgroundColor: 'rgba(139,115,85,0.05)' } }} aria-label={social.label}>
                    {social.icon}
                  </IconButton>
                ))}
              </Box>
            </motion.div>
          </Grid>
        </Grid>

        <Box sx={{ mt: 2, pt: 1.5, borderTop: '1px solid rgba(139,115,85,0.15)', textAlign: 'center' }}>
          <Typography variant="body2" sx={{ opacity: 0.85, fontSize: '0.8rem', color: '#5C4A3D' }}>
            © 2024 Ahmed Shareef Sofas. All rights reserved. | Powered by{' '}
            <Link href="https://moksha-technologies.com" target="_blank" rel="noopener noreferrer" sx={{ color: '#8B7355', textDecoration: 'none', fontWeight: 600, '&:hover': { color: '#5C4A3D', textDecoration: 'none' } }}>
              MS Technologies
            </Link>
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
